<template>
  <div>
    <v-alert color="#D3EAFD" light>
      <v-row>
        <v-col cols="12" md="10">
          <v-row>
            <v-col cols="12" md="8">
              <h3>Seleksi Peserta</h3>
              <span>Proses Set Kriteria, Penilaian, Permeringkatan dan Pengajuan Proporsi</span>
            </v-col>
            <v-col cols="12" md="4">
              <span class="caption grey--text">Waktu Penyelesaian</span>
              <h3>{{ $localDate((tahap && tahap.wkt_proses) || '') }}</h3>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="2">
          <span class="caption grey--text">Data yang ditampilkan</span>
          <v-select
            v-model="kJenjang"
            :items="options"
            placeholder="Pilih Jenjang"
            dense
            outlined
            hide-details
            background-color="info"
            dark
            @input="onFilterJenjang"
          ></v-select>
        </v-col>
      </v-row>
    </v-alert>
    <v-list-item v-if="kJenjang">
      <v-list-item-avatar color="warning" size="60">
        <v-icon dark>mdi-google-classroom</v-icon>
      </v-list-item-avatar>
      <v-list-item-content class="py-0 px-1">
        <span class="caption grey--text">Jenjang</span>
        <div class="subtitle-2 blue--text">
          {{ mJenjang && mJenjang[kJenjang] && mJenjang[kJenjang]['text'] }}
          ({{ mJenjang && mJenjang[kJenjang] && mJenjang[kJenjang]['keterangan'] }})
        </div>
      </v-list-item-content>
    </v-list-item>
    <list-peserta
      ref="peserta"
      type="lolos"
      :options="{ btnDownload: true }"
      :is-pusat="true"
      :is-edit="false"
      :detail="getDetailJenjang(kJenjang)"
      v-if="kJenjang"
      :jenjang-id="kJenjang"
      @download="onDownload"
    ></list-peserta>
  </div>
</template>

<script>
import ListPeserta from '../../components/base/ListKasek';
import { mapActions } from 'vuex';
export default {
  name: 'Kandidat',
  components: { ListPeserta },
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      kJenjang: '',
    };
  },
  computed: {
    tahap() {
      const tahaps = this.$getDeepObj(this.detail, 'psp_peringkat_tahaps') || [];
      const filtered = tahaps.filter((item) => item.k_tahap_peringkat_psp === 4);
      const idx = filtered.length - 1;
      return (filtered && filtered[idx]) || {};
    },

    options() {
      const jenjangs = this.$getDeepObj(this.detail, 'psp_peringkat_jenjangs') || [];
      return jenjangs.map((item) => {
        return {
          text: this.$getDeepObj(item, 'm_jenjang.singkat'),
          value: item.psp_peringkat_jenjang_id,
          keterangan: this.$getDeepObj(item, 'm_jenjang.keterangan'),
        };
      });
    },
    mJenjang() {
      return this.$arrToObj(this.options, 'value');
    },
  },
  methods: {
    ...mapActions('peringkatVerval', ['downloadList']),

    onFilterJenjang() {
      if (!this.kJenjang) return;
      this.$nextTick(() => {
        this.$refs.peserta.params = Object.assign(this.$refs.peserta.params, { page: 1 });
        this.$refs.peserta.fetchData();
      });
    },

    getDetailJenjang(jenjangId) {
      const jenjangs = this.$getDeepObj(this.detail, 'psp_peringkat_jenjangs') || [];
      const idx = jenjangs.findIndex((item) => item.psp_peringkat_jenjang_id === jenjangId);
      return jenjangs[idx];
    },

    onDownload(params) {
      this.downloadList({ params, url: `jenjang/${this.kJenjang}/lolos-download` }).then((url) => {
        window.open(url, '_blank');
      });
    },
  },
};
</script>

<style scoped></style>
